module.exports = __webpack_public_path__ + "static/media/Filter1.4405764c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/Filter1.gif
// module id = 21
// module chunks = 0